import React, { useEffect, useState } from 'react';

//Header Data


import {getLayoutGallery, getSearchResultDesign, getDesignSearchPageNumber } from '../../store/Selectors';
import DslStore, { setDesignSearchPageNumber, setLayoutGallery } from '../../store/DslStore';
import { useStoreState } from 'pullstate';

import DesignCard from '../../components/Design/DesignCard/DesignCard';
import DesignRow from '../../components/Design/DesignCard/DesignRow';
import { GalleryDesign } from '../../global';

import DesignSearchNavigation, { DesignSearchPaginationSwitch } from '../../components/SearchNavigation/DesignSearchNavigation';

const DesignSearch: React.FC = () => {
  const layoutGallery = useStoreState(DslStore, getLayoutGallery);
  const pageNumber = useStoreState(DslStore, getDesignSearchPageNumber);
  const designs = useStoreState(DslStore, getSearchResultDesign);
  const [visibleDesigns, setVisibleDesigns] = useState<GalleryDesign[]>([]);

  const arraysfill = () => {
    let chunkSize = 20;
    let startchunk = (pageNumber - 1) * chunkSize;
    let tempArray: GalleryDesign[] = [];
    let chunk: GalleryDesign[] = designs.slice(startchunk, startchunk + chunkSize);
    console.log(designs);

    for (let i = 0; i < designs.length; i += chunkSize) {
      chunk = designs.slice(startchunk, startchunk + chunkSize);
    }
    for (let i = 0; i < chunkSize; i++) {
      if (chunk[i] !== undefined) {
        tempArray.push(chunk[i]);
      } else {
        break;
      }
    }
    console.log(tempArray);
    setVisibleDesigns(tempArray);
  };

  useEffect(() => {
    arraysfill();
  }, [designs]);

  useEffect(() => {
    console.log(pageNumber);

    console.log(visibleDesigns);

    arraysfill();
  }, [pageNumber]);


  return (
    <div className="bg-light-gray">
      <main className={`container pt-5 mb-5 px-sm-0 overflow-hidden`}>
        <div className="row ">
          <DesignSearchNavigation onChangeLayout={setLayoutGallery} />
        </div>
        <div className="row ">
          {layoutGallery === 1
              ? visibleDesigns.map((aPublicDesign: GalleryDesign, index: number) => (
                  <div className=" col-12 col-md-6 col-lg-4 col-xl-3">
                    <DesignCard key={index} design={aPublicDesign} />
                  </div>
                ))
            : ''}
        </div>
        <div className="row mt-3 px-sm-1">
          <div className="px-sm-3">
            {layoutGallery === 2
                ? visibleDesigns.map((aPublicDesign: GalleryDesign, index: number) => <DesignRow key={index} design={aPublicDesign} />)
              : ''}
          </div>
        </div>
        <div className="row px-2">
          <div className="col-12 px-4 d-flex justify-content-sm-start justify-content-md-end ">
            <DesignSearchPaginationSwitch onChangePage={setDesignSearchPageNumber} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default DesignSearch;
